(function () {
    "use strict";

    angular.module("app").controller("ScreeningHistoryController", ScreeningHistoryController);

    ScreeningHistoryController.$inject = [];
    function ScreeningHistoryController() { }
})();